import React, { Component } from 'react';
import Container from 'react-bootstrap/Container'

import "./style.css";
import BandejaComponent from './component';
import reducer from "./reducer";
import { createStore, applyMiddleware, combineReducers } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from "redux-saga";
import { watchUsers } from "./saga";
import { Provider } from 'react-redux';
import { reducer as formReducer } from 'redux-form';
import { AuthProvider } from '../../components/authprovider/auth';
import { Auth0Provider } from "@auth0/auth0-react";

import LinearProgress from '@material-ui/core/LinearProgress';
import { getTipoAuth } from '../../controller/firebase';

const sagaMiddleware = createSagaMiddleware();
const rootReducer = combineReducers({
    localReducer: reducer,
    form: formReducer,
});

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(watchUsers);

export default class AdminPage extends Component {

    state = {
        tipoAuth: null
    };

    async componentWillMount() {
        const tipoAuth = await getTipoAuth();
        this.setState({ tipoAuth });
    }
    render() {
        const { tipoAuth } = this.state;

        // Bloquea el render hasta que tengas la respuesta
        if (tipoAuth === null) {
            return (
                <div className="loading-wrapper">
                    <LinearProgress />
                    <div>
                        <p>Cargando configuración de autenticación...</p>
                    </div>
                </div>
            );
        }

        const contenido = (
            <Provider store={store}>
                <Container className='main-wrapper admin' >
                    <BandejaComponent urlParams={this.props.match.params} tipoAuth={tipoAuth} />
                </Container>
            </Provider>
        );



        if (tipoAuth === 'auth0') {
            
            return (
                <AuthProvider>
                    <Auth0Provider
                        domain={process.env.REACT_APP_AUTH0_COLABORADOR_DOMAIN}
                        clientId={process.env.REACT_APP_AUTH0_COLABORADOR_CLIENTID}
                        redirectUri={`${window.location.origin}/bandeja`}
                    >
                        {contenido}
                    </Auth0Provider>
                </AuthProvider>
            );
        }

        return contenido;

    }
}
